import { trackPublicView, trackPublicTeaser, trackClickout } from '@/api/analytics'

/**
 * Fire-and-forget analytics beacons for the in-app (private) surfaces. Everyone
 * counts — owner and members included; the server gates non-public collections
 * to their owner/members and dedups per identity per 30 minutes.
 */
export function beaconCollectionView(collectionId) {
  if (!collectionId) return
  trackPublicView({ collectionId }).catch(() => {})
}

// Item detail view — only items living in a collection have stats
export function beaconItemView(item) {
  if (!item?.isCollectionItem) return
  trackPublicView({ collectionId: item.ownerId, itemId: item.id }).catch(() => {})
}

// Click on a bookmark's source link (notes have no destination)
export function beaconClickout(item) {
  if (!item?.isCollectionItem || !item.url) return
  trackClickout({ collectionId: item.ownerId, itemId: item.id }).catch(() => {})
}

// Teaser impression: { collectionId } for a collection card, { collectionId, itemId } for an item card
export function beaconTeaser(body) {
  if (!body?.collectionId) return
  trackPublicTeaser(body).catch(() => {})
}
